import router from "@/router";

/**
 * @param {Object} routerOptions
 * @param {String} routerOptions.name
 * @param {Object} routerOptions.params
 * @constructor
 */
var MobileDeviceBridgeOpenUrlHandler = function (routerOptions) {

    if (!routerOptions) { throw 'Required parameter "routerOptions" missing.' }

    /**
     * @returns {Object} notification
     * @returns {String} notification.command
     * @returns {String} notification.value
     */
    this.invokeNotification = function () {
        let fullPath;
        if (!routerOptions.fullPath) {
            fullPath = _constructFullPath();
        } else {
            fullPath = routerOptions.fullPath;
        }
        return { command: 'OPEN_URL', instance: fullPath };
    }

    /**
     * @returns {string}
     * @private
     */
    var _constructFullPath = function () {
        let origin = window.location.origin;
        let href = router.resolve(routerOptions).href;
        return `${origin}${href}`;
    }
};

export default MobileDeviceBridgeOpenUrlHandler;
